import { startOfTomorrow } from 'consts/dates';
import * as Yup from 'yup';
import { addDays } from 'date-fns';

export const READ_ONLY_FIELDS = {
  id: Yup.number().integer(),
  isActive: Yup.bool().required().default(false),
};

export const EDITABLE_FIELDS = {
  name: Yup.string().required().default('').label('campaign.name'),
  startDate: Yup.date().default(startOfTomorrow).label('campaign.startDate'),
  endDate: Yup.date()
    .default(addDays(startOfTomorrow, 30))
    .label('campaign.endDate'),
  products: Yup.array().of(Yup.number()).default([]).label('campaign.products'),
  mediaAgency: Yup.number()
    .integer()
    .default(null)
    .nullable()
    .label('campaign.mediaAgency'),
  client: Yup.number()
    .integer()
    .required()
    .default(null)
    .nullable()
    .label('campaign.client'),
};

export const HISTORY_FIELDS = {
  active: Yup.bool().label('campaign.active'),
};

export const FORM_VALIDATION_SCHEMA = Yup.object().shape(EDITABLE_FIELDS);

export const campaignSchema = Yup.object().shape({
  ...READ_ONLY_FIELDS,
  ...EDITABLE_FIELDS,
  ...HISTORY_FIELDS,
});

export type CampaignInterface = Yup.InferType<typeof campaignSchema>;

export const STATUS_FIELD = {
  status: Yup.string().default('').label('campaign.status'),
};

export const STATUS_UPDATE_SCHEMA = Yup.object().shape(STATUS_FIELD);

export const OWNER_FIELD = {
  owner: Yup.string().default('').label('campaign.owner'),
};

export const OWNER_UPDATE_SCHEMA = Yup.object().shape(OWNER_FIELD);
